// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"1398ef86","171":"af696b44","208":"7fc70241","238":"6c7aaf95"}[chunkId] + ".chunk.js";
};